import { PatientDto } from '@lmt/shared-types';
import { getFormattedDate } from '@lmt/unicorn-shared/app/components/patients/common';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { localizeSexType } from '@lmt/unicorn-shared/app/helpers/localization/translations';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getContacts, getNumberPostfix } from './common';

import styles from './MergePair.module.scss';

interface Props {
  firstPatient: PatientDto | undefined;
  secondPatient: PatientDto | undefined;
}

export const SearchPatientsFieldsTable: FC<Props> = (props) => {
  const i18next = useScopedTranslation('merge_assistant.merge_pair');
  const i18n = useTranslation();
  const { firstPatient, secondPatient } = props;

  const TitleColumn = (
    <div className={styles.column}>
      <div className={styles.patientDataTitle}>
        {i18next.t('fields.number')}
      </div>
      <div className={styles.patientDataTitle}>
        {i18next.t('fields.first_name')}
      </div>
      <div className={styles.patientDataTitle}>
        {i18next.t('fields.last_name')}
      </div>
      <div className={styles.patientDataTitle}>
        {i18next.t('fields.date_of_birth')}
      </div>
      <div className={styles.patientDataTitle}>{i18next.t('fields.sex')}</div>
      <div className={styles.patientDataTitle}>
        {i18next.t('fields.contacts')}
      </div>
    </div>
  );

  const PatientDataColumn = (patient: PatientDto) => (
    <div className={styles.patientDataColumn}>
      <div className={styles.patientDataText}>
        {patient.number +
          getNumberPostfix(
            patient.numberSource,
            i18next.t('external_patient_number'),
          )}
      </div>
      <div className={styles.patientDataText}>{patient.firstName}</div>
      <div className={styles.patientDataText}>{patient.lastName}</div>
      <div className={styles.patientDataText}>
        {getFormattedDate(patient.dateOfBirth)}
      </div>
      <div className={styles.patientDataText}>
        {localizeSexType(patient.sex)}
      </div>
      <div className={styles.patientDataText}>{getContacts(patient)}</div>
    </div>
  );

  const EmptyMessage = (
    <div className={styles.emptyTextContainer}>
      <div className={styles.emptyText}>{i18next.t('no_patient')}</div>
    </div>
  );

  return (
    <>
      {TitleColumn}
      {firstPatient ? PatientDataColumn(firstPatient) : EmptyMessage}
      <div />
      {secondPatient ? PatientDataColumn(secondPatient) : EmptyMessage}
    </>
  );
};
